export const contactDefaultErrors = {
  common: [],
  fields: {},
}
